// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qx-5";
export var filledCircle = "_qx-4";
export var historyEntry = "_qx-3";
export var messageSideLeft = "_qx-1";
export var messageSideRight = "_qx-2";
export var orderTrackingCarouselWrapper = "_qx-6";
export var orderTrackingInfoContainer = "_qx-0";